export default {
      id: "exit-fullscreen-usage",
      viewBox: "0 0 128 128",
      url: __webpack_public_path__ + "static/img/icons.38294312.svg#exit-fullscreen",
      toString: function () {
        return this.url;
      }
    }